module.exports = __webpack_public_path__ + "media/assets/icons/general-3b12aea6da9e0e4556ed97aad6991b98.svg";